import { ResolveFn } from '@angular/router';
import { map, zip } from 'rxjs';
import { ApiService } from '@services';
import { inject } from '@angular/core';

export const customerResolver: ResolveFn<any> = (route, state) => {
  const url: Array<string> = [`/admin-user/customer-support-dashboard/list`];
  const api = inject(ApiService);
  const profileData = api.get(url[0]).pipe(map((response) => response));
  return profileData;
};

 